//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.8.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------

export enum UserRole {
    User = 0,
    Admin = 1,
    SuperAdmin = 100,
}

export interface UserEntry {
    id: string | undefined;
    email: string | undefined;
    userRole: UserRole | undefined;
    platforms: string[] | undefined;
    countries: string[] | undefined;
    dashboardEnabled: boolean | undefined;
    translationsReviewEnabled: boolean | undefined;
    statusChangeEnabledLevel: number;
    userManagementEnabled: boolean | undefined;
    publicationConfiguratorEnabled: boolean | undefined;
    logsExplorerEnabled: boolean | undefined;
    exportVersionEnabled: boolean | undefined;
    importVersionEnabled: boolean | undefined;
    configuratorEnabled: boolean | undefined;
    featuresReviewEnabled: boolean | undefined;
}
